import { Stimulus, Controller } from "#/layouts/js/stimulus"

Stimulus.register("copy-dl", class extends Controller {
  async copy() {
    const button = this.element
    const link = button.nextElementSibling.href

    try {
      await navigator.clipboard.writeText(link)
      button.classList.add("btn-success")
      button.classList.remove("btn-secondary")
      button.innerText = "Copied!"
    } catch {
      button.classList.add("btn-danger")
      button.classList.remove("btn-secondary")
      button.innerText = "Error"
    }

    setTimeout(() => {
      button.classList.remove("btn-success", "btn-danger")
      button.classList.add("btn-secondary")
      button.innerText = "Copy Link"
    }, 1500)
  }
})
